import { StoreType } from '@tock/shared/utils/connect';
import { consumer, core } from '@tock/coretypes';
import { createSelector } from 'reselect';
import { keyBy, sortBy } from 'es-toolkit/compat';

export const patronAchievementsSelector = createSelector(
  (state: StoreType) => state.patron.achievements,
  (patronAchievements) => sortBy(patronAchievements, ['name'])
);

export const allAchievementsSelector = createSelector(
  (state: StoreType) => state.patron.allAchievements,
  (allAchievements) => sortBy(allAchievements, ['name'])
);

export interface PatronAndFullAchievementPair {
  patronAchievement: core.PatronProfileAchievement | undefined;
  fullAchievement: consumer.AchievementDescription;
}

export const patronAndFullAchievementsSelector = createSelector(
  patronAchievementsSelector,
  allAchievementsSelector,
  (
    patronAchievements: core.PatronProfileAchievement[],
    allAchievements: consumer.AchievementDescription[]
  ): PatronAndFullAchievementPair[] => {
    const patronAchievementNameToAchievement = keyBy(patronAchievements, 'name');

    const pairedAchievements: PatronAndFullAchievementPair[] = [];

    allAchievements.forEach((fullAchievement) =>
      pairedAchievements.push({
        fullAchievement,
        patronAchievement: patronAchievementNameToAchievement[fullAchievement.name] || undefined,
      })
    );

    return sortBy(pairedAchievements, ['patronAchievement', 'fullAchievement.name']);
  }
);
